module.exports = __webpack_public_path__ + "static/media/11.f75e0633.jpg";